import { useState, useEffect } from 'react';
import axios from 'axios';
import ExcelDownload from '../../../component/common/button/ExcelDownload';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';

import { Search16w } from '../../../images/icons/icons_component';

function UserTelLog_popup() {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().setMonth(new Date().getMonth() - 1) + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        urdbemcd: JSON.parse(localStorage.getItem('telLogCode')).code,
    });
    const dataHead = ['No.', '업무구분', '성명', '근무부서', '직위', '연락처', '핸드폰', '이메일', '알림여부', '업무 시작일', '업무 종료일', '등록/수정일시'];
    const dataColumn = ['SEQ', 'URDBTYPE', 'URDBNAME', 'URDBDEPT', 'URDBGRDE', 'URDBTEL1', 'URDBCELL', 'URDBMAIL', 'URDBSDMA', 'URDBWKSTDT', 'URDBWKENDT', 'URDBCRDTTM'];
    const apiCall = '/commonapi/agent/getTelinfoLog.do';
    const apiCntCall = '';
    const excelFileName = '전원전담코디네이터_수정이력';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        loadingHeight: '6rem'
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 10, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const search = async () => {
        console.log(searchParams);
        try {
            setState((prev) => ({
                ...prev,
                isLoading: true,
            }));
            const response = await axios.get(apiCall, {
                params: searchParams,
            });
            setState((prev) => ({
                ...prev,
                dataList: response.data,
                isSearched: true,
                isLoading: false,
            }));
            setPageInfo((prev) => ({
                ...prev,
                totalItems: response.data.length,
            }))
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    return (
        <div className='popup_container bg_ho_bg'>
            <h5>수정이력 조회 세부창</h5>
            <div className='flex flex-col'>
                <div className="com-search ho_pop_th_bg" style={{ borderTop: 'var(--ho-primary-border)' }}>
                    <table>
                        <colgroup>
                            <col width="10%" />
                            <col width="20%" />
                            <col width="10%" />
                            <col width="20%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>등록년월</th>
                                <td>
                                    <input
                                        type="date"
                                        name="searchFromdate"
                                        value={searchParams.searchFromdate}
                                        onChange={handleInputChange}
                                    />
                                    &nbsp;~&nbsp;
                                    <input
                                        type="date"
                                        name="searchTodate"
                                        value={searchParams.searchTodate}
                                        onChange={handleInputChange}
                                        min={searchParams.searchFromdate}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='search_btn_wrapper'>
                    <span className='total_items'>전체&nbsp;<strong className='ho_primary'>{pageInfo.totalItems}</strong>건</span>
                    <div className='btn_container'>
                        <button onClick={search} className='search_btn bg_ho_primary'><Search16w />검색</button>
                        <ExcelDownload
                            excelHead={dataHead}
                            excelData={state.dataList}
                            searched={state.isSearched}
                            dataCode={dataColumn}
                            excelFileName={excelFileName}
                        />
                    </div>
                </div>
                <div className='ho_pop' >
                    <NewDataGrid
                        propsInfo={propsInfo}
                        state={state}
                        pageInfo={pageInfo}
                        setPageInfo={setPageInfo}
                    />
                </div>
            </div>
        </div>
    );
}

export default UserTelLog_popup;